var exports = {
  "Pc": "TagListField.module__tagsContainer___aWNfVW",
  "Pr": "TagListField.module__tagsHeader___aWNfVW",
  "cm": "TagListField.module__tagsLabel___aWNfVW",
  "jw": "TagListField.module__tagInputRow___aWNfVW",
  "Cs": "TagListField.module__tagsList___aWNfVW",
  "Tc": "TagListField.module__tag___aWNfVW",
  "xH": "TagListField.module__tagRemoveButton___aWNfVW",
};

module.exports = exports;
